import cx from 'classnames'

import styles from './select.module.css'

interface ItemState {
  isFocused: boolean
  isDisabled: boolean
}

// pair with react-select's `unstyled`, so these classes are the whole look
export const selectClassNames = {
  control: ({ isFocused, isDisabled }: ItemState) =>
    cx(
      styles.control,
      isFocused && styles.focused,
      isDisabled && styles.disabled
    ),
  valueContainer: () => styles.valueContainer,
  placeholder: () => styles.placeholder,
  singleValue: () => styles.singleValue,
  input: () => styles.input,
  multiValue: () => styles.multiValue,
  multiValueLabel: () => styles.multiValueLabel,
  multiValueRemove: () => styles.multiValueRemove,
  clearIndicator: () => styles.indicator,
  dropdownIndicator: () => styles.indicator,
  loadingIndicator: () => styles.indicator,
  indicatorSeparator: () => styles.indicatorSeparator,
  menu: () => styles.menu,
  menuList: () => styles.menuList,
  option: ({ isFocused, isDisabled }: ItemState) =>
    cx(
      styles.option,
      isFocused && styles.focused,
      isDisabled && styles.disabled
    ),
  noOptionsMessage: () => styles.notice,
  loadingMessage: () => styles.notice,
  group: () => styles.group,
  groupHeading: () => styles.groupHeading
}
